import { getThresholdSchema } from './thresholdSchema';
import { units, getValidUnitsForType } from '../../../../units';

const unitsAllowedForGroupedBar = getValidUnitsForType('grouped-bar');

// Unlike BarGaugeVisualizationSchema, unit/unitLabel here apply to the whole visualization
// (one value for every bar), not per signal - see VISUALIZATIONS_WITH_UNIT_IN_CONFIG on the backend.
const getProperties = (variables = []) => ({
  title: {
    type: 'string',
    title: 'Title',
  },
  layout: {
    type: 'string',
    title: 'Layout',
    default: 'vertical',
    // inverted layout naming due to issues when switching in component
    oneOf: [
      {
        enum: ['vertical'],
        title: 'horizontal',
      },
      {
        enum: ['horizontal'],
        title: 'vertical',
      },
    ],
  },
  unit: {
    type: 'string',
    title: 'Unit',
    default: units[0].id,
    oneOf: unitsAllowedForGroupedBar.map((unit) => ({
      enum: [unit.id],
      title: `${unit.category}: ${unit.name}`,
    })),
    description: 'Automatic unit conversion (e.g., kW to MW) is applied to default signal units',
  },
  unitLabel: {
    type: 'string',
    title: 'Custom unit label',
    description: 'This takes precedence over Unit',
  },
  decimals: {
    default: 'auto',
    title: 'Decimals',
    type: 'string',
    enum: ['auto', '0', '1', '2', '3', '4', '5'],
  },
  ...getThresholdSchema(variables),
});

export const getSchema = (variables = []) => ({
  type: 'object',
  properties: getProperties(variables),
});

export const uiSchema = {
  unit: {
    'ui:field': 'customUnitLabel',
  },
  unitLabel: {
    'ui:field': 'customUnitLabel',
  },
  thresholds: {
    areaItems: {
      'ui:options': {
        orderable: false,
      },
    },
    linearItems: {
      'ui:options': {
        orderable: false,
      },
    },
  },
};
